// frontend-crm/src/pages/SuperAdmin/SuperAdminUsuarios.js
import React from 'react';
import { Box, Typography, Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Chip } from '@mui/material';
import { useQuery } from 'react-query';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function SuperAdminUsuarios() {
  const { data: res, isLoading } = useQuery('superadmin-todos-usuarios', () =>
    fetch(`${API_URL}/api/superadmin/tenants/usuarios/all`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(r => r.json())
  );

  const usuarios = res?.data || [];

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ color: '#fff', mb: 4, fontWeight: 700 }}>Gestión Global de Usuarios</Typography>
      <Card sx={{ bgcolor: '#0D1117', border: '1px solid rgba(255,255,255,0.06)' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: 'rgba(255,255,255,0.4)' }}>Nombre</TableCell>
              <TableCell sx={{ color: 'rgba(255,255,255,0.4)' }}>Email</TableCell>
              <TableCell sx={{ color: 'rgba(255,255,255,0.4)' }}>Tipo</TableCell>
              <TableCell sx={{ color: 'rgba(255,255,255,0.4)' }}>Empresa (Tenant)</TableCell>
              <TableCell sx={{ color: 'rgba(255,255,255,0.4)' }}>Estado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usuarios.map(u => (
              <TableRow key={u.id}>
                <TableCell sx={{ color: '#fff' }}>{u.nombre}</TableCell>
                <TableCell sx={{ color: 'rgba(255,255,255,0.6)' }}>{u.email}</TableCell>
                <TableCell>
                  <Chip label={u.tipo} size="small" />
                </TableCell>
                <TableCell sx={{ color: 'rgba(255,255,255,0.6)' }}>{u.Tenant?.nombre || 'SuperAdmin'}</TableCell>
                <TableCell>
                   <Chip label={u.estado} color={u.estado === 'activo' ? 'success' : 'error'} size="small" variant="outlined" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </Box>
  );
}
